<template>
  <button :class="value ? 'active' : ''" class="toggle-button" @click="changeValue"></button>
</template>

<script>
export default {
  name: "Select",
  props: {
    value: {
      type: [Boolean, Number],
    },
  },
  watch: {
    value(newvalue) {
      console.log(newvalue);
    },
  },
  methods: {
    changeValue() {
      this.$emit("input", !this.value);
    },
  },
  mounted() {
    console.log(this.value);
  },
};
</script>

<style scoped>
.toggle-button.active {
  background: #6aff46;
}

.toggle-button.active:before {
  transform: translateX(30px);
}
</style>
